import * as core from '../../../../../../../core'

import { query } from './overview-trends.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.overview.widgets.trends',
    description:
      'Bar chart showing trends in expenses at an Institution level over the last five years.',
    name: 'RP Overview - Trends',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
